import { Component, input } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-energy-interfaces-empty-box',
  imports: [Button, NgIcon, RouterLink, TranslocoPipe],
  templateUrl: './energy-interfaces-empty-box.html',
})
export class EnergyInterfacesEmptyBox {
  organizationId = input.required<string>();
}
